import React from "react";
import { motion } from "framer-motion";
import { Button } from "antd";
import confetti from "canvas-confetti";

const SuccessCard = ({ message, isVisible, onClose }) => {
  // Fire confetti when the card is shown
  React.useEffect(() => {
    if (isVisible) {
      confetti({
        particleCount: 200,
        spread: 100,
        origin: { y: 0.6 },
      });
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative bg-white rounded-3xl shadow-xl p-6 text-center max-w-xs border-2 border-yellow-400"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/3059/3059529.png"
          alt="Video Meeting Booked"
          className="w-20 h-20 mx-auto animate-bounce"
          style={{ filter: "invert(46%) sepia(81%) saturate(350%) hue-rotate(90deg)" }}
        />  
        {/* Success Content */}
        <h2 className="text-2xl font-bold text-green-500 mt-4">🎊 Congratulations!</h2>
        <p className="text-gray-600 mt-2">{message}</p>

        {/* Close Button */}
        <Button
          className="mt-4 bg-blue-500 hover:bg-blue-600 text-white px-6 rounded-full font-semibold shadow-md transition-all duration-300"
          onClick={onClose}
        >
          OK
        </Button>
      </motion.div>
    </div>
  );
};

export default SuccessCard;
